<template>
  <div class="wrapper panel panel-default"
       v-if="readyToRender">
    <div class="panel-title">
      <h3>Demandes de validation en attente</h3>
      <router-link :to="{ name: 'demands' }">
        <button class="btn btn-sm btn-complete">Voir tout</button>
      </router-link>
    </div>
    <div class="panel-body">
      <p v-if="requests.length > 0" class="activities-info text-danger">
        <i class="fa fa-warning"></i>
        Si le client d'une demande de validation de contrat n'apparaît pas dans le CRM, cela signifie que <strong>vous ne devez pas le relancer</strong>.
      </p>
      <activities-tabs v-if="requests.length > 0">
        <activities-tab title="Tous"
                        :is-active="true">
          <div v-if="all_grouped_requests.length > 0" style="max-height: 520px; overflow-y: scroll;">
            <activities-log-item v-for="(group, idx) in all_grouped_requests"
                                 :key="'requests-all-'+idx"
                                 :request_group="all_grouped_requests[idx]">
            </activities-log-item>
          </div>
          <p v-else class="no-request">Aucune demande de ce type</p>
        </activities-tab>
        <activities-tab title="Contrats">
          <div v-if="contract_grouped_requests.length > 0" style="max-height: 520px; overflow-y: scroll;">
            <activities-log-item v-for="(group, idx) in contract_grouped_requests"
                                 :key="'requests-contracts-'+idx"
                                 :request_group="contract_grouped_requests[idx]">
            </activities-log-item>
          </div>
          <p v-else class="no-request">Aucune demande de ce type</p>
        </activities-tab>
        <activities-tab title="Clients">
          <div v-if="customer_grouped_requests.length > 0" style="max-height: 520px; overflow-y: scroll;">
            <activities-log-item v-for="(group, idx) in customer_grouped_requests"
                                 :key="'requests-customer-'+idx"
                                 :request_group="customer_grouped_requests[idx]">
            </activities-log-item>
          </div>
          <p v-else class="no-request">Aucune demande de ce type</p>
        </activities-tab>
      </activities-tabs>
      <p v-else>Aucune demande en attente</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .panel-body {
    max-height: 789px;

    .activities-info {
      font-size: 15px;
      margin-bottom: 20px;
    }

    .no-request {
      padding: 12px;
    }
  }

  .panel-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    h3 {
      padding: 0 10px 0 0;
      max-width: 250px;
    }
  }

  ul {
    display: flex;
    justify-content: space-between;
    padding: 0;
    li {
      width: 25%;
      a {
        width: 100%;
        display: inline-block;
        text-align: center;
        &.active {
          border-bottom: 3px solid #fb557c;
        }
      }
    }
  }
</style>

<script type="text/babel">
  import ActivitiesLogItem from "components/Dashboard/ActivitiesLog/ActivitiesLogItem"
  import ActivitiesTabs from "components/Dashboard/ActivitiesLog/ActivitiesTabs"
  import ActivitiesTab from "components/Dashboard/ActivitiesLog/ActivitiesTab"

  export default {

    name: "ActivitiesLog",

    props: ["requests"],

    computed: {
      all_grouped_requests () {
        const grouped = _.groupBy(this.requests, (request) => moment(request.attributes.created_at).format('L'))
        const keys = _.keys(grouped)
        return _.map(keys, (date) => { return { date: date, requests: grouped[date] } })
      },

      contract_grouped_requests () {
        if (this.all_grouped_requests) {
          const copy_of_grouped_request = _.clone(this.all_grouped_requests)
          const results = _.map(copy_of_grouped_request, (request_group) => {
            var request_group_for_contract = _.clone(request_group)
            return _.assign(request_group_for_contract, {
              requests: _.filter(request_group.requests, (request) => {
                return request.included.type.attributes.group == "contract"
              })
            })
          })
          return _.filter(results, (result) => result.requests.length > 0)
        }
      },

      customer_grouped_requests () {
        if (this.all_grouped_requests) {
          const copy_of_grouped_request = _.clone(this.all_grouped_requests)
          const results = _.map(copy_of_grouped_request, (request_group) => {
            var request_group_for_contract = _.clone(request_group)
            return _.assign(request_group_for_contract, {
              requests: _.filter(request_group.requests, (request) => {
                return request.included.type.attributes.group == "customer"
              })
            })
          })
          return _.filter(results, (result) => result.requests.length > 0)
        }
      },

      readyToRender () {
        return this.requests && this.all_grouped_requests && this.contract_grouped_requests && this.customer_grouped_requests ? true : false
      },

    },

    components: {
      ActivitiesLogItem,
      ActivitiesTabs,
      ActivitiesTab,
    },
  }

</script>



// WEBPACK FOOTER //
// client/components/Dashboard/ActivitiesLog/ActivitiesLog.vue